import { render, staticRenderFns } from "./MatchFieldSelection.vue?vue&type=template&id=fb1487b0&scoped=true&"
import script from "./MatchFieldSelection.vue?vue&type=script&lang=js&"
export * from "./MatchFieldSelection.vue?vue&type=script&lang=js&"
import style0 from "./MatchFieldSelection.vue?vue&type=style&index=0&id=fb1487b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1487b0",
  null
  
)

export default component.exports